import { Card } from 'antd';
import { FortnightlyForm } from '../../components/Fortnightly/FortnightlyForm';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';

export const Fortnightly = () => {
  return (
    <Card bordered={true} title={<TitleBreadcrumbs />} className="gx-card">
      <FortnightlyForm />
    </Card>
  );
};
